import { forwardRef, Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { DependencyTreeCanActivate } from 'app/core/guards/dependency-tree.guard';
import { GetDefinitionsGuard } from 'app/core/store/definitions/definitions.resolve';
import { RelocationDetailCreateFromTemplateAction } from 'app/core/store/edit-relocation-detail/relocation-detail.actions';
import { AuthorizationGuard } from 'app/core/store/session/authorization/authorization.resolve';
import { Observable, of } from 'rxjs';
import * as fromRoot from '..';
import { TemplateRestService } from '../../services/rest/template.rest.service';
import { logger } from 'app/core/util/logger';
import { goAction } from '../router/router.actions';
import { switchMap } from 'rxjs/operators';

/**
 * Guard to async load an order before following a route
 */
@Injectable({ providedIn: 'root' })
export class CreateRelocationFromTemplateGuard implements CanActivate, DependencyTreeCanActivate {
  private templateRestService: TemplateRestService;
  private store: Store<fromRoot.RootState>;

  constructor(@Inject(forwardRef(() => Store)) store, @Inject(forwardRef(() => TemplateRestService)) templateRestService) {
    this.store = store;
    this.templateRestService = templateRestService;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    logger.debug(`In CreateRelocationFromTemplateGuard`);
    return this.templateRestService.getTemplate('RELOCATION', parseInt(route.paramMap.get('templateId'), 10)).pipe(
      switchMap(template => {
        // Reducer to store in state
        this.store.dispatch(
          new RelocationDetailCreateFromTemplateAction({
            template,
            date: route.queryParamMap.get('date'),
          })
        );
        // Go to /orders/copy
        this.store.dispatch(goAction({ path: '/relocation/copy' }));
        return of(true);
      })
    );
  }

  getDependencies(): any {
    return [AuthorizationGuard, GetDefinitionsGuard];
  }

  getDependencyRouteData(): any {
    return {
      authorization: 'canRelocate',
    };
  }
}
